function toNumber(value) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
}

/**
 * Resolve exam display name from honor-panel / home payload shapes.
 * Supports panel-level and per-student fields when the API provides them.
 */
export function getHonorExamName(payload, students) {
    const list = Array.isArray(students) ? students : [];
    const sources = [
        payload,
        payload && payload.exam,
        list[0],
        list[0] && list[0].exam,
    ].filter(Boolean);

    for (let i = 0; i < sources.length; i += 1) {
        const source = sources[i];
        const candidate =
            source.exam_name
            || source.exam_title
            || source.examName
            || (source.exam && typeof source.exam === 'object'
                ? (source.exam.name || source.exam.title)
                : null)
            || (typeof source.exam === 'string' ? source.exam : null);

        if (candidate && String(candidate).trim()) {
            return String(candidate).trim();
        }
    }

    return null;
}

function parseTime(value) {
    if (!value && value !== 0) {
        return null;
    }
    if (typeof value === 'number') {
        return value;
    }
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
}

export function getHonorScore(student) {
    if (!student) {
        return { earned: null, total: null, percentage: null };
    }

    const earned = toNumber(
        student.correction_mark != null
            ? student.correction_mark
            : student.score != null
                ? student.score
                : student.mark
    );
    const total = toNumber(
        student.total_mark != null
            ? student.total_mark
            : student.max_mark != null
                ? student.max_mark
                : student.full_mark
    );

    let percentage = toNumber(student.correction_percentage);
    if (percentage == null && earned != null && total) {
        percentage = (earned / total) * 100;
    }

    return { earned, total, percentage };
}

export function getHonorFinishTime(student) {
    if (!student) {
        return null;
    }

    return (
        student.submitted_at
        || student.finish_time
        || student.finished_at
        || student.end_time
        || student.completed_at
        || null
    );
}

export function getHonorTimeTaken(student) {
    if (!student) {
        return null;
    }

    const taken = toNumber(student.time_taken || student.duration_taken || student.elapsed_time);
    return taken;
}

export function rankHonorStudents(students) {
    if (!students || !students.length) {
        return [];
    }

    const ranked = students
        .map((student, index) => {
            const score = getHonorScore(student);
            const finishRaw = getHonorFinishTime(student);
            const finishAt = parseTime(finishRaw);
            const timeTaken = getHonorTimeTaken(student);

            return {
                ...student,
                rankSourceIndex: index,
                earnedMark: score.earned,
                totalMark: score.total,
                scorePercentage: score.percentage,
                finishTime: finishRaw,
                finishAt,
                timeTaken,
            };
        })
        .sort((a, b) => {
            const aPct = a.scorePercentage == null ? -1 : a.scorePercentage;
            const bPct = b.scorePercentage == null ? -1 : b.scorePercentage;
            if (bPct !== aPct) {
                return bPct - aPct;
            }

            const aTaken = a.timeTaken == null ? Number.POSITIVE_INFINITY : a.timeTaken;
            const bTaken = b.timeTaken == null ? Number.POSITIVE_INFINITY : b.timeTaken;
            if (aTaken !== bTaken) {
                return aTaken - bTaken;
            }

            const aFinish = a.finishAt == null ? Number.POSITIVE_INFINITY : a.finishAt;
            const bFinish = b.finishAt == null ? Number.POSITIVE_INFINITY : b.finishAt;
            if (aFinish !== bFinish) {
                return aFinish - bFinish;
            }

            return a.rankSourceIndex - b.rankSourceIndex;
        });

    return ranked.map((student, index) => ({
        ...student,
        rank: index + 1,
    }));
}
